import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=2c0da825"
import script from "./AdminContainer.vue?vue&type=script&lang=js"
export * from "./AdminContainer.vue?vue&type=script&lang=js"
import style0 from "./AdminContainer.vue?vue&type=style&index=0&id=2c0da825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_cache-loader@4.1.0_webpac_6f95da160c08ac8dc5724deda4dd3901/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports